import { Overlay, OverlayRef, PositionStrategy } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { LoaderComponent } from '../components/loader/loader.component';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private overlayRef: OverlayRef;
  private isLoading: boolean;
  private count = 0;
  private timeoutThatMakesLoaderVisible: number;
  private isLoaderVisible: boolean;
  private dateOfAnimationStart: number;
  private readonly LOADER_CLASS_VISIBLE: string = 'loader-visible';
  private readonly LOADER_CLASS_NOT_VISIBLE: string = 'loader-not-visible';
  private readonly LOADER_BACKDROP_CLASS: string = 'loader-backdrop';

  constructor(private overlay: Overlay) {}

  public open() {
    this.count++;
    if (!this.isLoading) {
      this.isLoading = true;
      this.overlayRef = this.overlay.create({
        hasBackdrop: true,
        panelClass: this.LOADER_CLASS_NOT_VISIBLE,
        backdropClass: this.LOADER_BACKDROP_CLASS,
        positionStrategy: this.createPositionStrategy(),
        height: '100vh',
        width: '100vw',
      });
      const portal = new ComponentPortal(LoaderComponent);
      this.overlayRef.attach(portal);
      this.timeoutThatMakesLoaderVisible = window.setTimeout(() => {
        this.makeLoaderVisible();
      }, 400);
    }
  }

  public close(): void {
    this.count--;
    this.count = this.count < 0 ? 0 : this.count;
    if (this.count === 0 && this.isLoading) {
      if (this.isLoaderVisible) {
        const timeOfAnimation = Date.now() - this.dateOfAnimationStart;
        if (timeOfAnimation >= 700) {
          this.closeLoaderThatIsVisible();
        } else {
          setTimeout(() => {
            this.closeLoaderThatIsVisible();
          }, 700 - timeOfAnimation);
        }
      } else {
        this.closeLoaderThatIsNotVisible();
      }
    }
  }

  private makeLoaderVisible() {
    this.overlayRef.removePanelClass(this.LOADER_CLASS_NOT_VISIBLE);
    this.overlayRef.addPanelClass(this.LOADER_CLASS_VISIBLE);
    this.isLoaderVisible = true;
    this.dateOfAnimationStart = Date.now();
  }

  private closeLoaderThatIsVisible() {
    this.isLoaderVisible = false;
    this.overlayRef.dispose();
    this.isLoading = false;
  }

  private closeLoaderThatIsNotVisible() {
    this.isLoading = false;
    clearTimeout(this.timeoutThatMakesLoaderVisible);
    this.overlayRef.dispose();
  }

  private createPositionStrategy(): PositionStrategy {
    return this.overlay.position().global().centerHorizontally().centerVertically();
  }
}
